




















module.exports =
  props: ['event', 'contact']

  data: ->
    current_user: Session.current_user




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/events/task_destroyed_event.vue